// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"64ca9992","404":"0ace9c5a","408":"6c5be2a7","500":"7f09ba4d","938":"da23fffa"}[chunkId] + ".chunk.js";
};